import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/partner/assisted-registration";

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (isSuccess === false) {
    return {
      isSuccess: false,
      data: null,
      message: res?.message ?? res?.Message ?? fallbackMessage,
      statusCode: res?.statusCode ?? res?.StatusCode,
    };
  }
  return {
    isSuccess: true,
    data: res?.data ?? res?.Data ?? null,
    message: res?.message ?? res?.Message,
  };
};

const OperatorAssistedRegistrationApi = {
  start: async (mobile) => {
    const response = await api.request({
      url: `${BASE}/start`,
      method: "POST",
      data: { mobile },
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "ارسال کد تأیید ناموفق بود.");
  },

  verifyOtp: async (mobile, otpCode) => {
    const response = await api.request({
      url: `${BASE}/verify-otp`,
      method: "POST",
      data: { mobile, otpCode },
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "کد تأیید نامعتبر است.");
  },

  getDetail: async (registrationId) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت اطلاعات ناموفق بود.");
  },

  parseLocation: async (locationInput) => {
    const response = await api.request({
      url: `${BASE}/parse-location`,
      method: "POST",
      data: { locationInput },
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "پردازش موقعیت ناموفق بود.");
  },

  saveProfile: async (registrationId, profile) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}/profile`,
      method: "PUT",
      data: profile,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "ذخیره پروفایل ناموفق بود.");
  },

  saveRequest: async (registrationId, request) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}/request-form`,
      method: "POST",
      data: request,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "ذخیره اطلاعات نیروگاه ناموفق بود.");
  },

  submit: async (registrationId) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}/submit`,
      method: "POST",
      headers: authHeader(),
    });
    return normalize(response.data, "ارسال برای بررسی ناموفق بود.");
  },

  getSummary: async (registrationId) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}/summary`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت خلاصه ناموفق بود.");
  },

  getList: async () => {
    const response = await api.request({
      url: BASE,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت لیست ناموفق بود.");
  },

  getTracking: async (registrationId) => {
    const response = await api.request({
      url: `${BASE}/${registrationId}/tracking`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت وضعیت پیگیری ناموفق بود.");
  },
};

export default OperatorAssistedRegistrationApi;
